import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { ContractTableFilterSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/contract/_list/')({
  validateSearch: zodValidator(ContractTableFilterSchema)
});